<mbs-modal
  #modal
  [isCustomModal]="true"
  [loading]="isLoading()"
  [showFooter]="true"
  [title]="('shared:forceUpdate.title' | i18next) + (!isGroupAction ? ': ' + computerName() : '')">
  <div modal-body>
    @if (!isLoading() && (isGroupAction || installedAgents().length)) {
      <form
        class="mbs-form"
        [formGroup]="forceUpdateForm">
        <fieldset class="mbs-form_content">
          @if (isGroupAction) {
            <p
              class="mb-3"
              [attr.data-e2e]="elementSelectors.name.groupHint">
              {{ (isSandBoxAvailable() ? 'shared:forceUpdate.groupHintWithSandbox' : 'shared:forceUpdate.groupHint') | i18next }}
            </p>
          }

          @for (view of agentViews(); track view.agentType; let first = $first; let last = $last) {
            <section
              class="d-flex column-gap-2"
              [attr.data-e2e]="elementSelectors.name.section + '-' + view.agentType"
              [ngClass]="{ 'pt-3': !first, 'pb-3 border-bottom': !last }">
              <span
                class="mbs-agent mbs-agent-md-small"
                [ngClass]="view.iconClass"></span>
              <div class="flex-grow-1">
                <h5 class="lh-base fw-semibold mb-0 pb-1">{{ view.title }}</h5>

                @if (view.buildOffers.length) {
                  <mbs-force-update-new-version-alert
                    class="d-block mt-2"
                    [attr.data-e2e]="elementSelectors.name.newVersionAlert + '-' + view.agentType"
                    [busyActions]="view.busyActions"
                    [canManageBuilds]="canManageBuilds"
                    [disabled]="isAnyBuildInProgress()"
                    [offers]="view.buildOffers"
                    [showReleaseNotes]="showReleaseNotes()"
                    (actionClick)="runBuildAction($event, view.productKey)"></mbs-force-update-new-version-alert>
                }

                @if (view.showOptions) {
                  <div class="d-flex flex-wrap column-gap-4 row-gap-2 mt-2">
                    <mbs-radio
                      class="mt-0"
                      [attr.data-e2e]="elementSelectors.name.option + '-' + view.agentType + '-' + forceUpdateAgentType.NotNecessary"
                      [formControlName]="view.agentType"
                      [id]="view.agentType + 'Id' + forceUpdateAgentType.NotNecessary"
                      [label]="
                        isGroupAction
                          ? ('shared:forceUpdate.doNotUpdate' | i18next)
                          : ('shared:forceUpdate.doNotUpdateKeep' | i18next: { version: view.agent.currentVersion })
                      "
                      [labelSize]="labelSize"
                      [name]="view.agentType + 'RadioControl'"
                      [value]="forceUpdateAgentType.NotNecessary"></mbs-radio>
                    @for (option of view.options; track option.value) {
                      <mbs-radio
                        class="mt-0"
                        [attr.data-e2e]="elementSelectors.name.option + '-' + view.agentType + '-' + option.value"
                        [formControlName]="view.agentType"
                        [id]="view.agentType + 'Id' + option.value"
                        [label]="optionLabelTemplate"
                        [labelContext]="option"
                        [labelSize]="labelSize"
                        [name]="view.agentType + 'RadioControl'"
                        [value]="option.value"></mbs-radio>
                    }
                  </div>
                } @else {
                  <mbs-status
                    class="mt-2"
                    [attr.data-e2e]="elementSelectors.name.status + '-' + view.agentType"
                    [icon]="view.statusIcon"
                    [textSize]="statusTextSize">
                    @if (!view.agent.online) {
                      {{ 'shared:forceUpdate.offline' | i18next }}
                    } @else if (!view.agent.forceUpdateSupporting) {
                      {{ 'shared:forceUpdate.cannotUpdateAutomatically' | i18next }}
                    } @else {
                      {{ 'shared:forceUpdate.latestInstalled' | i18next }} (v{{ view.agent.currentVersion }})
                    }
                  </mbs-status>
                }
              </div>
            </section>
          }
        </fieldset>
      </form>
    }

    @if (!isLoading() && !isGroupAction && !installedAgents().length) {
      <mbs-alert
        class="mb-0"
        [attr.data-e2e]="elementSelectors.name.noAgentAlert"
        [type]="alertType.warning">
        {{ 'shared:forceUpdate.noAgentInstalled' | i18next }}
      </mbs-alert>
    }
  </div>
  <ng-container modalFooter>
    @if (hasUpdateOptions()) {
      <mbs-button
        type="primary"
        [attr.data-e2e]="elementSelectors.name.updateButton"
        [disabled]="!forceUpdateForm.valid"
        [loading]="isSubmitting()"
        (click)="handleResolve()">
        {{ 'shared:buttons.update' | i18next }}
      </mbs-button>
    }
    <mbs-button
      data-dismiss="modal"
      type="secondary"
      (click)="modal.close()">
      {{ 'shared:buttons.close' | i18next }}
    </mbs-button>
  </ng-container>
</mbs-modal>

<ng-template
  #optionLabelTemplate
  let-option>
  {{
    (isGroupAction ? 'shared:forceUpdate.updateToBuilds' : 'shared:forceUpdate.updateToBuild')
      | i18next: { type: (versionLabelKeys[option.versionType] | i18next) }
  }}
  @if (option.version) {
    (v{{ option.version }})
  }
</ng-template>
